import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { SignalsStoreService } from '../signals-store.service';
import { PaymentMethodModalService } from '../../settings/billing/payment-method/payment-method-modal.service';

@Component({
  selector: 'app-past-due-banner',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule],
  templateUrl: './past-due-banner.component.html',
  styleUrl: './past-due-banner.component.scss',
})
export class PastDueBannerComponent {
  private signalsStore = inject(SignalsStoreService);
  private paymentModals = inject(PaymentMethodModalService);

  /** Null unless the backend flags the account, which is what keeps this inert
   *  until `billing.isAtRisk` starts arriving. Suspended accounts are handled by
   *  their own screen, so the reminder would be noise there. */
  banner = computed(() => {
    const session = this.signalsStore.sessionSignal();
    const billing = session?.billing;

    if (!billing?.isAtRisk) return null;
    if (session?.settings?.isSuspended) return null;

    return {
      balance: billing.pastDueBalance ?? 0,
      daysUntil: billing.daysUntilSuspension ?? null,
    };
  });

  /** This brand charges a card on file, so a past-due balance means the charge
   *  failed and the fix is a new card. */
  onCta() {
    this.paymentModals.openEditPaymentMethod();
  }
}
